module.exports = __webpack_public_path__ + "static/ghoul-a52d7279b4aca4e4d35ae571141c75d0.png";